import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Ensures smooth scrolling
    });
  };

  return (
    <footer className="footer  text-white py-4   jab_footer">
      <Container className="mt-3">
        <Row>
          <Col md={6} className="mb-3 ">
            <h5 className="text-uppercase fw-bold">
              Journal of Applied Bioanalysis
            </h5>
            <p className="mb-0 fw-bold">Open Access</p>
            <p className="mb-1">
              Address: Unit 860, 8th Floor, JMD Megapolis, <br /> Gurugram,
              Haryana, 122018
            </p>
            <p className="mb-0">
              Journal of Applied Bioanalysis is published by{" "}
              <a
                href="https://www.gpubpress.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontWeight: "bold",
                  color: "#4a7eb7",
                  textDecoration: "underline",
                }}
              >
                Green Publication
              </a>
            </p>
            {/* <p  >Contact</p> */}
          </Col>

          <Col md={6}>
            <Row>
              <Col xs={6}>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      to="/"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      About Us
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/contact-us"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/submit-article"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Submit Article
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/copyright"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Copyright
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col xs={6}>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      to="/privacy"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/terms-condition"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Terms and Conditions
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/journal-information"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      Journal Information
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/information/article-processing-charges/0-general-information-on-article-processing-charges-apc"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      {" "}
                      Article Processing Charges
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/information/editorial-criteria-and-processes/0--how-to-submit-an-article-"
                      className="text-white text-decoration-none"
                      onClick={handleScrollToTop}
                    >
                      {" "}
                      Editorial Criteria and Processes
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className="border-secondary" />
        {/* <Row className="text-center">
          <Col>
            <p className="mb-0">
              <a
                href="https://creativecommons.org/licenses/by/4.0/"
                className="text-white"
              >
                Licensed
              </a>{" "}
              under CC BY 4.0
            </p>
          </Col>
        </Row> */}
        <Row className="text-center">
          <Col>
            <p className="mb-0">
              <a href="https://creativecommons.org/licenses/by/4.0/"
                target="_blank">
                <img
                  src="https://i.creativecommons.org/l/by/4.0/88x31.png"
                  alt="CC BY 4.0"
                  className="inline-block mr-2"
                  style={{ verticalAlign: 'middle' }}
                />
              </a>
              <a
                href="https://creativecommons.org/licenses/by/4.0/"
                className="text-primary"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                Creative Commons «Attribution» 4.0
              </a>
              {" "}WorldWide.
            </p>
          </Col>
        </Row>
      </Container>
    </footer >
  );
};

export default Footer;
